import React from "react";
import { Link } from "react-router-dom";
import "./styles/Profile.css";
import ProfileLayout from "../components/ProfileLayout";
import ProfileAddresses from "../components/ProfileAddresses";
import { ListSkeleton } from "../components/Skeleton";
import { connect } from "react-redux";
import * as actions_session from "../redux/actions/sessionActions";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { Translate, I18n } from "react-redux-i18n";

function FieldRow({ label, children, onSave, saving, disabled }) {
  return (
    <div className="profile-data-field">
      <label className="profile-edit-label">{label}</label>
      <div className="profile-data-field__row">
        <div className="profile-data-field__input">{children}</div>
        <button
          type="button"
          className="profile-data-field__save"
          onClick={onSave}
          disabled={disabled || saving}
          aria-label="Save"
        >
          <FaSave />
        </button>
      </div>
    </div>
  );
}

class ProfileData extends React.Component {
  state = {
    form: {
      gender: "",
      ocupation: "",
      birthday: "",
    },
    savingField: null,
    ready: false,
  };

  handleChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  normalizeBirthday = (value) => {
    if (!value) {
      return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return typeof value === "string" ? value.slice(0, 10) : "";
    }
    return date.toISOString().slice(0, 10);
  };

  async componentDidMount() {
    await this.props.LoadAll(this.props.user_id, this.props.token);

    if (this.props.profile) {
      this.setState({
        form: {
          gender: this.props.profile.Gender || "",
          ocupation: this.props.profile.Ocupation || "",
          birthday: this.normalizeBirthday(this.props.profile.Birthday),
        },
        ready: true,
      });
    } else {
      this.setState({ ready: true });
    }
  }

  onClickSave = async (fieldName, fieldValue) => {
    this.setState({ savingField: fieldName });

    try {
      await this.props
        .EditUser(this.props.token, {
          field_name: fieldName,
          field_value: fieldValue,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error_update) {
            alertify.warning(I18n.t(this.props.error_update));
          } else {
            alertify.success(I18n.t("saved_succesfull"));
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ savingField: null });
    }
  };

  render() {
    const { form, savingField, ready } = this.state;
    const loading = !ready;

    return (
      <ProfileLayout>
        <div className="profile-data-page profile-edit-page">
          <div className="card profile-edit-card">
            <div className="profile-edit-header profile-data-header">
              <Link
                to="/profile"
                className="profile-edit-back"
                aria-label="Back"
              >
                <FaArrowLeft />
              </Link>
              <div>
                <h3 className="profile-edit-title">
                  <Translate value="profile_data" />
                </h3>
                <p className="profile-edit-subtitle">
                  @{this.props.profile?.username || ""}
                </p>
              </div>
            </div>

            {loading ? (
              <div className="profile-edit-form">
                <ListSkeleton />
              </div>
            ) : (
              <div className="profile-edit-form">
                <div className="profile-data-section">
                  <ProfileAddresses />
                </div>

                <section className="profile-data-section">
                  <h4 className="profile-data-section__title">
                    <Translate value="profile_data" />
                  </h4>

                  <FieldRow
                    label={<Translate value="profile_ocupation" />}
                    onSave={() =>
                      this.onClickSave("ocupation", form.ocupation)
                    }
                    saving={savingField === "ocupation"}
                  >
                    <input
                      name="ocupation"
                      className="form-control profile-edit-input"
                      placeholder={I18n.t("profile_ocupation")}
                      value={form.ocupation}
                      onChange={this.handleChange}
                    />
                  </FieldRow>

                  <FieldRow
                    label={<Translate value="profile_birthday" />}
                    onSave={() =>
                      this.onClickSave("birthday", form.birthday)
                    }
                    saving={savingField === "birthday"}
                  >
                    <input
                      type="date"
                      className="form-control profile-edit-input"
                      name="birthday"
                      value={form.birthday}
                      onChange={this.handleChange}
                      min="1900-01-01"
                      max={new Date().toISOString().slice(0, 10)}
                    />
                  </FieldRow>

                  <FieldRow
                    label={<Translate value="profile_gender" />}
                    onSave={() => this.onClickSave("gender", form.gender)}
                    saving={savingField === "gender"}
                  >
                    <select
                      className="form-control profile-edit-input"
                      name="gender"
                      onChange={this.handleChange}
                      value={form.gender}
                    >
                      <option value="">{I18n.t("profile_select")}</option>
                      <option value="MALE">{I18n.t("profile_male")}</option>
                      <option value="FEMALE">
                        {I18n.t("profile_female")}
                      </option>
                    </select>
                  </FieldRow>
                </section>
              </div>
            )}
          </div>
        </div>
      </ProfileLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    profile: reducer.session.auth,
    error: reducer.session.error,
    error_update: reducer.session.error_update,
  };
}

const mapDispatchToProps = (dispatch) => ({
  EditUser: (token, params) =>
    dispatch(actions_session.updatefield({ token, params })),
  LoadAll: (user_id, token) =>
    dispatch(actions_session.loadItemAll({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileData);
